import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../contexts/LanguageContext';

// A small popup for validation/save errors (e.g. "Title is required") - these used to render as
// an inline line of text near the bottom of the form, easy to miss now that the title field
// moved up into the modal header (collapsed behind a pencil icon) instead of sitting right there
// in the form where the error used to point. Styled to actually read as an error (red icon badge,
// red button) rather than reusing the neutral gray look of the unsaved-changes confirmation.
const ErrorModal = ({ message, onClose }) => {
  const { t } = useLanguage();
  if (!message) return null;

  return (
    <div className="modal-overlay" style={{ zIndex: 1001 }}>
      <div className="modal-content" style={{ maxWidth: '420px', width: '90%', margin: '0 auto' }}>
        <div style={{ padding: '28px 24px 8px 24px', textAlign: 'center' }}>
          <div
            style={{
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              background: '#fee2e2',
              color: '#dc3545',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px auto',
              fontSize: '22px'
            }}
          >
            <FontAwesomeIcon icon={faTriangleExclamation} />
          </div>
          <h3 style={{ margin: '0 0 10px 0', fontSize: '18px', fontWeight: '700', color: '#374151' }}>
            {t('common.error')}
          </h3>
          <p style={{ margin: '0', fontSize: '14px', color: '#6b7280', lineHeight: '1.5' }}>{message}</p>
        </div>
        <div style={{ padding: '20px 24px 24px 24px', display: 'flex', justifyContent: 'center' }}>
          <button type="button" className="salon-button danger" onClick={onClose} style={{ padding: '10px 36px', fontSize: '14px' }}>
            {t('common.close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
